import React from 'react'
import "./style.css";


export const Button = (prop) => {
  return (
    
    <button onClick={prop.onClick} className='primary-button button'>{prop.children}</button>
  )
}


export const GhostButton = (prop) => {
  return (
    <button onClick={prop.onClick} className='ghost-button button'>{prop.children}</button>
  )
}
